import React from "react";
import styled from "styled-components";
import {
  Heading,
  BasicText,
  Highlighter,
  Container,
  Heading3
} from "../styles";

class Image extends React.Component {
  render() {
    return (
      <Container>
        <Heading>Image</Heading>
        <BasicText style={{ paddingTop: 15, marginBottom: 20 }}>
          By default, on Android, an <Highlighter>{"<Image/>"}</Highlighter>{" "}
          fades in with a 300ms delay. With the normalized component, there is
          no fade animation.
        </BasicText>
        <Heading3>Usage</Heading3>

        <BasicText>
          You just need to import<Highlighter>Image</Highlighter>
          from <b>react-native-normalized</b> instead of <b>react-native!</b>
        </BasicText>
      </Container>
    );
  }
}

export default Image;
